import axios from 'axios'
const endpoint = process.env.VUE_APP_BASE_API + '/api/job/driver'

export default {
  async countAll(period, mode) {
    return await axios
      // .get(endpoint + '/count')
      .get(endpoint + `/count?period=${period}&mode=${mode}`)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async getAll(filter) {
    return await axios
      .get(endpoint + `/list${filter}`)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async getDetail(reservationId) {
    return await axios
      .get(endpoint + `/detail/${reservationId}`)
      .then(response => {
        return response.data.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async confirmDriver(request) {
    return await axios
      .post(endpoint + '/driver/confirm', request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async declineDriver(request) {
    return await axios
      .post(endpoint + '/driver/decline', request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
}



// WEBPACK FOOTER //
// ./src/services/job/driverJob/inquiryDriverJobService.js